import fullscreen from 'vue-fullscreen';
import Vue from 'vue';

Vue.use(fullscreen);
